import axios, { AxiosRequestConfig, AxiosError, AxiosResponse } from "axios";
import { ApiResponse, ErrorResponse } from "../types/api";
import i18n from "../utils/lang/i18n.config";

const axiosConfig: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
};

const instance = axios.create(axiosConfig);

const getAccessToken = (): string | null => {
  return localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");
};

instance.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();
    if (accessToken && config.headers) {
      config.headers.authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response: AxiosResponse<ApiResponse>) => {
    return response;
  },
  (error: AxiosError<ErrorResponse>) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("accessToken");
      sessionStorage.removeItem("accessToken");
      window.location.href = "/login";
    }

    const defaultErrorMessage = i18n.t('unknownError') || "알 수 없는 오류가 발생했습니다.";
    const errorMessage = error.response?.data?.message || defaultErrorMessage;
    return Promise.reject(new Error(errorMessage));
  }
);

export default instance;
